<script>
import RbxRemoteCombobox from '../../../shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '../../../shared/reybex/RbxRemoteComboboxMultiple';
import fieldVisibilityMixin from '../../../mixins/fieldVisibility';

export default {
  name: 'AvContractControlRightsForm',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
  },
  mixins: [fieldVisibilityMixin],
  props: {
    avContract: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hiddenFieldsDomain: 'avContract',
    };
  },
};
</script>

<template>
  <div class="avContract-detail-tab main-tab">
    <v-layout row wrap>
      <!-- eslint-disable -->
      <!-- Basic information left column -->
      <v-flex md12 xs12>
        Der Nachweis solcher Maßnahmen; die nicht nur den konkreten Auftrag betreffen; kann erfolgen durch
        <v-layout row wrap>

          <v-flex v-if="isFieldVisible('avContract.isProvedByBehaviorRules')" xs12 md6 py-0>
            <v-checkbox
              v-model="avContract.isProvedByBehaviorRules"
              label="die Einhaltung genehmigter Verhaltensregeln gemäß Art. 40 DS-GVO"
              class="caption"
              hide-details
            />
          </v-flex>

        </v-layout>
        <v-layout row wrap>

          <v-flex v-if="isFieldVisible('avContract.isProvedByCert')" xs12 md6 py-0>
            <v-checkbox
              v-model="avContract.isProvedByCert"
              label="die Zertifizierung nach einem genehmigten Zertifizierungsverfahren gemäß Art. 42 DS-GVO"
              class="caption"
              hide-details
            />
          </v-flex>

        </v-layout>
        <v-layout row wrap>

          <v-flex v-if="isFieldVisible('avContract.isProvedByDocs')" xs12 md6 py-0>
            <v-checkbox
              v-model="avContract.isProvedByDocs"
              label="aktuelle Testate, Berichte oder Berichtsauszüge unabhängiger Instanzen (z.B. Wirtschaftsprüfer, Revision, Datenschutzbeauftragter, IT-Sicherheitsabteilung, Datenschutzauditoren, Qualitätsauditoren)"
              class="caption"
              hide-details
            />
          </v-flex>

        </v-layout>
        <v-layout row wrap>

          <v-flex v-if="isFieldVisible('avContract.isProvedByAudit')" xs12 md6 py-0>
            <v-checkbox
              v-model="avContract.isProvedByAudit"
              label="eine geeignete Zertifizierung durch IT-Sicherheits- oder Datenschutzaudit (z.B. nach BSI-Grundschutz)"
              class="caption"
              hide-details
            />
          </v-flex>
        </v-layout>
      <!-- eslint-enable -->

        <v-layout row wrap>
          <v-flex v-if="isFieldVisible('avContract.isOtherControlLawMeasures')" xs12 md6 py-0>
            <v-checkbox
              v-model="avContract.isOtherControlLawMeasures"
              label="sonstige Maßnahme"
              class="caption"
              hide-details
            />
          </v-flex>

        </v-layout>
        <v-layout row wrap>

          <v-flex
            v-if="isFieldVisible('avContract.otherControlLawMeasures')
            && avContract.isOtherControlLawMeasures == 1"
            xs12 md6
            py-0
          >
            <v-textarea
              v-model="avContract.otherControlLawMeasures"
              label="Beschreiben Sie die Maßnahme"
              class="caption"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
